import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CadastrarFotoComponent } from './cadastrar-foto.component';

const routes: Routes = [{ path: '', component: CadastrarFotoComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CadastrarFotoRoutingModule { }
